import {Box, Flex, Text, useMediaQuery, VStack} from "@chakra-ui/react";
import styles from "../login/styles";
import React from "react";
import {RegisterForm} from "../../../components/forms";
import {SuperList} from "./parts/SuperList";
import {GoogleAuth} from "../parts/GoogleAuth";
import {LogoHeader} from "../parts/LogoHeader";

export const Register = () => {
    const [isMobile] = useMediaQuery("(max-width: 1270px)");

    return (
        <Flex
            css={styles.loginContainer}
            mt={{base : '0', md : '0', lg: '86px'}}
            mx={'auto'}
            px={isMobile ? '10px' : '0'}
            flexDirection={isMobile ? 'column-reverse' : 'row'}
            justifyContent={isMobile ? 'center' : 'space-between'}
            alignItems={isMobile ? 'center' : 'start'}
            mb={{base : '0', md : '0', lg: '250px'}}
            w={{base : '100%', md : '100%', lg: '1280px'}}>
            <SuperList isMobile={isMobile}/>
            <Box maxW={ isMobile ? '100%' : '672px'} m={'auto'}>
                <VStack
                    p={isMobile ? '16px' : '53px'}
                    pt={isMobile ? '24px' : '53px'}
                    boxShadow={'0px 4px 4px 0px #00000040'}
                    border={'1px solid #23262F99'}
                    position={'relative'}
                    overflow={'hidden'}
                    maxW={'672px'}
                    borderRadius={'32px'}>
                    <LogoHeader
                        title={'Welcome to Arbito'}
                        text={'Please enter your email or phone number to sign up'}
                        />
                    <RegisterForm
                        isMobile={isMobile}/>
                    <Text
                        display={isMobile ? 'none': 'block'}
                        color={'#FFFFFF80'}
                        mt={'64px'}
                        w={'60%'}
                        fontSize={'body.xs'}
                        textAlign={'center'}>
                        By continuing, you agree to Langbase's Terms of Service and Privacy Policy, and to receive
                        periodic emails with updates.
                    </Text>
                </VStack>
                <GoogleAuth
                    isMobile={isMobile}/>
            </Box>
        </Flex>
    )
}